import { type ConfirmationModalProps, ConfirmationModal, Text } from '@shared/components';

export type DisableQuestionModalProps = Pick<
  ConfirmationModalProps,
  'loading' | 'open' | 'onAccept' | 'onClose'
>;

export default function DisableQuestionModal(props: Readonly<DisableQuestionModalProps>) {
  const { loading: isLoading, open: isOpen, onClose, onAccept } = props;

  return (
    <ConfirmationModal
      title='Disable Question?'
      open={isOpen}
      loading={isLoading}
      acceptText='Disable'
      content={
        <Text>
          เมื่อทำการ Disable แล้ว{' '}
          <Text variant='body1Semibold' component='span'>
            จะไม่สามารถแก้ไขรายละเอียดได้อีก
            <br />
            และระบบจะไม่นำคำถามนี้ไปใช้ในการ Generate ชุดข้อสอบ
          </Text>
          <br />
          <br />
          กรุณาตรวจสอบความถูกต้องให้เรียบร้อยก่อนดำเนินการต่อ
        </Text>
      }
      onDiscard={onClose}
      onClose={onClose}
      onAccept={onAccept}
    />
  );
}
